import { SiteState, SiteFilterValues } from '../redux/types';

const filterSites = (Logement: SiteState, endeds: string[], filterBy: SiteFilterValues) => {
//  console.log("filterClosed");
  switch (filterBy) {
    case 'all':
      return true;
    case 'closed':
//      if (String(Logement.date_end).length > 4) { return Logement; } else { return false };
      if(endeds.some((item) => Number(item) === Number(Logement.sn_site))) { return Logement } else { return false }
//      return Logement.suivi === true;
//      if (Logement.app_date_end !== null) { return false; } else { return true; }
//      if (new Date(Logement.app_date_end).getMilliseconds < new Date().getMilliseconds) { return true; } else { return false; };
    case 'running':
      if(!endeds.some((item) => Number(item) === Number(Logement.sn_site))) { return Logement } else { return false }
//      if (String(Logement.date_end).length === 4) { return Logement } else { return false };
//      return String(Logement.app_date_end).length === 4 ? true : false;
//      if (Logement.app_date_end === null) { return true; } else { return false; }
    //      if (Logement.app_date_end !== "") { return true; } else { return false; };
//      return Logement.isResolved === false;
  }
};

export default filterSites;